import React from "react";
import { FormControl } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import ReactDOM from 'react-dom';

export default class ReportsParameterCompany extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            companyList: []
        };

        this.getCompanyList = this.getCompanyList.bind(this);
        this.getCompanyList();
    }    

    handleChange() {
        var companies = '';

        // if (this.inputEl.selectedOptions.length > 0) {
        //     for (var i = 0; i < this.inputEl.selectedOptions.length; i++) {
        //         if (this.inputEl.selectedOptions[i].value == '') {
        //             companies = '';
        //             break;
        //         }
        //         else {
        //             companies += ',' + this.inputEl.selectedOptions[i].value;
        //         }
        //     }
        // }
        var companySelect = document.getElementById('CompanySelect');
        
        for (var i = 0; i < companySelect.options.length; i++) {
            if (companySelect[i].selected == true) {
                if (companySelect[i].value == '') {
                    companies = '';
                    break;
                }
                else {
                    companies += ',' + companySelect[i].value;
                }
            }
        }

        if (companies.length > 0) {
            companies = companies.substr(1, companies.length);
        }

        if (this.props.onChange)
            this.props.onChange(companies);
    }

    getCompanyList() {
        let self = this;
        ajax.api().get("get-company-by-ae")
            .then(function (res) {
                self.setState({ companyList: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    render() {
        var companyListToRender = [];
        companyListToRender.push(<option key="All" value="" selected="true">All</option>);
        
        this.state.companyList.map(function (item, i) {
            companyListToRender.push(<option key={item} value={item}>{item}</option>)
        }, this);

        return (   
            <div className="ap-report-control-dropdown">       
                <FormControl
                    id="CompanySelect"
                    componentClass="select"
                    multiple
                    onChange={this.handleChange.bind(this)}
                    inputRef={el => this.inputEl = el}>
                    {companyListToRender}
                </FormControl>
            </div>
        );
    }
}